/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StatusWorkflowDtoCreate } from '../../models/status-workflow-dto-create';
import { StatusWorkflowItem } from '../../models/status-workflow-item';

export interface StatusWorkflowControllerCreateStatusWorkflow$Params {
      body: StatusWorkflowDtoCreate
}

export function statusWorkflowControllerCreateStatusWorkflow(http: HttpClient, rootUrl: string, params: StatusWorkflowControllerCreateStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
  const rb = new RequestBuilder(rootUrl, statusWorkflowControllerCreateStatusWorkflow.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StatusWorkflowItem;
      }>;
    })
  );
}

statusWorkflowControllerCreateStatusWorkflow.PATH = '/status-workflow';
